import * as React from 'react';
import FormControl from '@material-ui/core/FormControl';

const CustomFormControl = (props) => {
    return <FormControl {...props} />;
};

export { CustomFormControl as FormControl };
